import { Routes } from "@angular/router";
import { PlatformComponent } from "./platform.component";
import { PageNotFoundComponent } from "./shared/page-not-found/page-not-found.component";
import { NoAccessComponent } from "./shared/no-access/no-access.component";
import { requireAuthenticated } from "./shared/auth/role.guard";

export const APP_ROUTES: Routes = [
  {
    path: "license",
    canActivate: [requireAuthenticated()],
    loadChildren: () => import("./license/license.routes").then((m) => m.LICENSE_ROUTES),
  },
  {
    path: "",
    component: PlatformComponent,
    children: [
      { path: "", redirectTo: "core", pathMatch: "full" },
      { path: "analysis", loadChildren: () => import("./analysis/analysis.routes").then((m) => m.ANALYSIS_ROUTES) },
      { path: "core", loadChildren: () => import("./core/core.routes").then((m) => m.CORE_ROUTES) },
      { path: "explore", loadChildren: () => import("./explore/explore.routes").then((m) => m.EXPLORE_ROUTES) },
      { path: "ingest", loadChildren: () => import("./ingest/ingest.routes").then((m) => m.INGEST_ROUTES) },
      { path: "monitor", loadChildren: () => import("./monitor/monitor.routes").then((m) => m.MONITOR_ROUTES) },
      { path: "no-access", component: NoAccessComponent },
      { path: "**", component: PageNotFoundComponent },
    ],
  },
];
